import { CardPersonDto, GetCartItemPresenter } from 'store/api-slice/hooks'
import {
    BundledProductsData,
    CardDetailDtoLimited,
    ProductType,
} from 'store/api-slice/types'
import {
    CARD_TYPE_UNLIMITED_BUNDLE,
    CARD_TYPE_UNLIMITED_BUNDLE_PLUS,
    PRODUCT_NAME_CARD,
    PRODUCT_TYPE_CARD,
    PRODUCT_TYPE_PARKING,
} from 'constants/app'

export const getVoucherFromVoucherBundle = (
    itemsBundle?: GetCartItemPresenter[]
): GetCartItemPresenter | undefined =>
    itemsBundle?.find(({ name }) =>
        name?.toLowerCase().includes(PRODUCT_NAME_CARD)
    )

interface CalculatePersonDetailForVoucherFromVoucherBundleProps {
    personsData: CardPersonDto[]
    description?: string
}

export const calculatePersonDetailForVoucherFromVoucherBundle = ({
    personsData,
    description,
}: CalculatePersonDetailForVoucherFromVoucherBundleProps):
    | CardPersonDto
    | undefined => {
    const voucherPerson = personsData?.find(
        ({ title, description: personDescription }) =>
            title === description || personDescription === description
    )

    return {
        key: voucherPerson ? voucherPerson.key : undefined,
        title: description,
    }
}

export const calculateCardDetailForVoucherFromVoucherBundle = (
    name?: string
): CardDetailDtoLimited => ({
    cardType: {
        value:
            name === 'Unlimited+'
                ? CARD_TYPE_UNLIMITED_BUNDLE_PLUS
                : CARD_TYPE_UNLIMITED_BUNDLE,
    },
})

export const calculateProductTypeForVoucherBundleItem = (
    name?: string
): ProductType =>
    name?.toLowerCase().includes(PRODUCT_NAME_CARD)
        ? PRODUCT_TYPE_CARD
        : PRODUCT_TYPE_PARKING

export const extractProductsDataForVoucherBundle = (
    itemsBundle?: GetCartItemPresenter[]
): BundledProductsData =>
    itemsBundle
        ? itemsBundle?.map(({ productId, name }) => ({
              productId: productId || '',
              productType: calculateProductTypeForVoucherBundleItem(name),
          }))
        : []
